import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './components/pages/LoginPage';
import WelcomePage from './components/pages/Welcome';           // ← NOU

import PricingPage from './components/pages/PricingPage';
import RegisterPage from './components/pages/RegisterPage';
import ForgetPasswordPage from './components/pages/ForgetPasswordPage';
import BasicPage from './components/pages/client/BasicPage';
import SimpleStatementPage from './components/pages/client/SimpleStatementPage';
import CustomPage from './components/pages/client/CustomPage';
import StandartPage from './components/pages/client/StandartPage';
import PremiumPage from './components/pages/client/PremiumPage';
import BusinessPage from './components/pages/client/BusinessPage';
import UltimatePage from './components/pages/client/UltimatePage';
import ITTicketPage from './components/pages/client/ITTicketPage';
import Enterprise from './components/pages/client/Enterprise';
import ConfirmationPage from './components/pages/ConfirmationPage';
import ShareTrucking from './components/pages/client/ShareTrucking';
import FaqPage from './components/pages/faq';
import ResetPasswordPage from './components/pages/ResetPasswordPage';
import PrivateRoute from './components/PrivateRoute';
import AboutUsPage from './components/pages/aboutus';
import ContactPage from './components/pages/ContactPage';
import SuperChatLoader from './components/shared/SuperChatLoader';
import ServicesPage from './components/pages/ServicesPage';
import VerificationMail from './components/shared/VerificationMail';
import SuccessPage from "./components/shared/SuccessPage";
import CancelPage from "./components/shared/CancelPage";
import { LoadScript } from "@react-google-maps/api";

const App = () => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Starea autentificării



 return (
    <>
      <SuperChatLoader isAuthenticated={isAuthenticated} />
      <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
        <Routes>
 
          {/* ── Rute publice ─────────────────────────────── */}
 
          {/* Welcome — prima pagina la intrarea pe site */}
          <Route path="/" element={<WelcomePage />} />
 
          {/* Login — acum accesibil la /login */}
          <Route
            path="/login"
            element={<LoginPage onLogin={() => setIsAuthenticated(true)} />}
          />
          
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/forget-password" element={<ForgetPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/trucking/:driverId/:shareLinkId" element={<ShareTrucking />} />
        <Route path="/FaqPage" element={<FaqPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<ServicesPage />} />
       
        <Route path="/verify-email/:clientId" element={<VerificationMail />} />
<Route path="/success" element={<SuccessPage />} />
  <Route path="/cancel" element={<CancelPage />} />

        {/* Rute protejate pentru paginile clienților */}
        <Route element={<PrivateRoute />}>
          <Route path="/client/basic/*" element={<BasicPage />} />
          <Route path="/client/standart/*" element={<StandartPage />} />
          <Route path="/client/premium/*" element={<PremiumPage />} />
          <Route path="/client/business/*" element={<BusinessPage />} />
          <Route path="/client/ultimate/*" element={<UltimatePage />} />
          <Route path="/client/ITTicket/*" element={<ITTicketPage/>} />
          <Route path="/client/enterprise/*" element={<Enterprise />} />
          <Route path="/client/simple-statement/*" element={<SimpleStatementPage />} />
          <Route path="/client/custom/*" element={<CustomPage />} />
        </Route>
      </Routes>
      </LoadScript>
    </>
  );
};

export default App;
